import { Reducer } from "redux";
import { PartialMatchQueueItem } from "../business-objects/common";
import { IMatchingQueueState, MatchingQueueActionTypes } from "../types";

// Type-safe initialState!
const initialState: IMatchingQueueState = {
  results: [],
  pagedResults: [],
  openWorkflowItemStep: null,
  loadingWorkflowSteps: false,
  totalWorkflowItemSteps: 0,
};

const reducer: Reducer<IMatchingQueueState> = (state = initialState, action) => {
  switch (action.type) {
    case MatchingQueueActionTypes.LOADING_WORKFLOW_STEPS: {
      return { ...state, loadingWorkflowSteps: action.value };
    }
    case MatchingQueueActionTypes.TOTAL_WORKFLOW_STEPS: {
      return { ...state, totalWorkflowItemSteps: action.value };
    }
    case MatchingQueueActionTypes.SEARCH_PARTIAL_MATCHES: {
      let _state = { ...state };
      _state = { ...state, results: action.value };
      return _state;
    }
    case MatchingQueueActionTypes.SEARCH_PARTIAL_MATCHES_PAGED: {
      let _state = { ...state };
      _state = { ...state, pagedResults: action.value };
      return _state;
    }
    case MatchingQueueActionTypes.OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case MatchingQueueActionTypes.ASSIGN_AND_OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case MatchingQueueActionTypes.UNASSIGN: {
      let _state = { ...state };
      _state.results = [
        ..._state.results.map((item) =>
          item.workflowItemStep.id == action.value.results[0].workflowItemStep.id
            ? { ...item, ...action.value.results[0] }
            : item
        ),
      ];
      _state.pagedResults = [
        ..._state.pagedResults.map((item) =>
          item.workflowItemStep.id == action.value.results[0].workflowItemStep.id
            ? {
                ...item,
                workflowItemStep: new PartialMatchQueueItem(
                  action.value.results[0].workflowItemStep
                ),
                matches: action.value.results[0].matches,
              }
            : item
        ),
      ];
      return _state;
    }
    case MatchingQueueActionTypes.MARK_AS_NEW: {
      let _state = { ...state };
      _state.results = _state.results.filter((item) => item.workflowItemStep.id != action.value.id);
      _state.pagedResults = _state.pagedResults.filter(
        (item) => item.workflowItemStep.id != action.value.id
      );
      return _state;
    }
    case MatchingQueueActionTypes.SEND_TO_MANAGEMENT: {
      let _state = { ...state };
      _state.results = _state.results.filter((item) => item.workflowItemStep.id != action.value);
      _state.pagedResults = _state.pagedResults.filter(
        (item) => item.workflowItemStep.id != action.value
      );
      return _state;
    }
    case MatchingQueueActionTypes.CANCEL_MERGE: {
      let _state = { ...state };
      _state.results = [
        ..._state.results.map((item) =>
          item.workflowItemStep.id == action.value.results[0].workflowItemStep.id
            ? { ...item, ...action.value.results[0] }
            : item
        ),
      ];
      _state.pagedResults = [
        ..._state.pagedResults.map((item) =>
          item.workflowItemStep.id == action.value.results[0].workflowItemStep.id
            ? {
                ...item,
                workflowItemStep: new PartialMatchQueueItem(
                  action.value.results[0].workflowItemStep
                ),
                matches: action.value.results[0].matches,
              }
            : item
        ),
      ];
      return _state;
    }
    case MatchingQueueActionTypes.COMPLETE_MERGE: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
